import { Component, Input } from '@angular/core';

export type UIBadgeVariant = 'success' | 'warning' | 'info' | 'danger' | 'none' | 'ghost';
export type UIBadgeSize = 'sm' | 'lg';

@Component({
    selector: 'app-badge',
    exportAs: 'appBadge',
    templateUrl: 'badge.component.html',
    styleUrls: ['badge.css'],
    standalone: false
})
export class UIBadgeComponent {

  @Input()
  public variant: UIBadgeVariant = 'none';

  @Input()
  public size: UIBadgeSize = 'sm';

  @Input()
  public title: string;

  @Input()
  public icon: string;

  public getClassNames(): string[] {
    return ['badge', this.variant && `badge--${this.variant}`, this.size && `badge--${this.size}`].filter(Boolean);
  }
}
